export interface ArticleSection {
  id: string;
  heading: string;
  paragraphs: string[];
}

export interface Article {
  id: string;
  category: string;
  title: string;
  summary: string;
  date: string;
  author: string;
  source: string;
  tags: string[];
  region: string;
  year: number;
  caseType?: string;
  cover: string;
  readTime: number;
  sections: ArticleSection[];
}

export const disclaimer =
  "本站内容为法律与伦理知识科普，部分示例与案例为虚构或去标识化处理，仅用于学习与讨论，不构成法律意见；如需具体法律帮助，请咨询执业律师或相关专业机构。";

export const articles: Article[] = [
  {
    id: "laws-01",
    category: "laws",
    title: "直系血亲与三代以内旁系血亲禁婚制度解析",
    summary:
      "从《民法典》婚姻家庭编的禁婚亲属规定出发，说明禁婚范围如何计算、违反禁婚规定的婚姻效力，以及立法背后的生物学与伦理考量。",
    date: "2026-08-18",
    author: "本站编辑部",
    source: "依公开法律法规整理",
    tags: ["禁婚亲属", "婚姻效力", "民法典"],
    region: "中国",
    year: 2021,
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20leather%20bound%20law%20books%20on%20a%20dark%20wooden%20desk%20with%20warm%20lamp%20light%2C%20deep%20navy%20and%20amber%20tones%2C%20professional%20legal%20library%20atmosphere%2C%20editorial%20still%20life%2C%20no%20people&width=800&height=600&seq=cov-c2-law-2026a&orientation=landscape",
    readTime: 8,
    sections: [
      {
        id: "s1",
        heading: "一、禁婚亲属的法律依据",
        paragraphs: [
          "我国《民法典》婚姻家庭编明确规定，直系血亲，以及三代以内的旁系血亲，禁止结婚。这一规定是对原《婚姻法》相关条款的延续，属于强制性规范，当事人之间的合意不能改变其效力。",
          "直系血亲指具有直接生育关系或法律拟制关系的上下各代亲属，例如父母与子女、祖父母与孙子女、外祖父母与外孙子女等，且不因是否共同生活而改变。法律拟制的直系血亲（如养父母与养子女）在禁婚问题上一般比照适用。",
        ],
      },
      {
        id: "s2",
        heading: "二、三代以内旁系血亲如何计算",
        paragraphs: [
          "旁系血亲的“三代”通常按“自己算一代、上数至同源血亲”的方式确定。同源于祖父母、外祖父母的旁系亲属，例如兄弟姐妹、堂兄弟姐妹、表兄弟姐妹、伯叔姑舅姨与侄（甥）子女等，一般纳入禁婚范围。",
          "实务中，判断是否属于禁婚范围的关键是寻找共同的祖先并计算代数，而非仅看称谓是否为“亲戚”。因此，远房表亲是否属于禁婚范围，需要具体计算而非一概而论。",
        ],
      },
      {
        id: "s3",
        heading: "三、违反禁婚规定的法律后果",
        paragraphs: [
          "禁婚亲属之间缔结的婚姻，因违反法律的强制性规定，属于无效婚姻情形。无效婚姻自始没有法律约束力，当事人之间不产生夫妻权利义务关系。",
          "婚姻被确认无效后，涉及的财产处理、子女抚养等问题，仍需按照法律关于非婚生子女权益保护等规定妥善解决，以保护未成年人的合法权益。",
        ],
      },
      {
        id: "s4",
        heading: "四、制度背后的考量",
        paragraphs: [
          "禁婚亲属制度的考量是多重的：既有降低隐性遗传病风险等生物学层面的考虑，也有维护家庭伦理秩序、防止家庭内部权力滥用与角色混乱等社会伦理层面的考虑。",
          "应当说明的是，该制度针对的是“结婚”这一法律行为，其规范目的与对家庭内部性侵犯的刑事规制、未成年人保护规范相互衔接，共同构成对家庭关系的法律保护网。",
        ],
      },
    ],
  },
  {
    id: "laws-02",
    category: "laws",
    title: "刑法视角下性侵犯罪中亲属情节的认定",
    summary:
      "梳理强奸罪、强制猥亵罪等相关罪名，说明亲属身份在定罪与量刑中可能产生的影响，以及实务认定中需要注意的证据规则。",
    date: "2026-07-30",
    author: "本站编辑部",
    source: "依公开法律法规整理",
    tags: ["刑法", "量刑情节", "证据规则"],
    region: "中国",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20legal%20paragraph%20symbol%20connected%20by%20thin%20geometric%20lines%20forming%20a%20network%2C%20dark%20navy%20background%20with%20subtle%20red%20highlights%2C%20modern%20editorial%20design%20concept%2C%20no%20people&width=800&height=600&seq=cov-c7-law-2026a&orientation=landscape",
    readTime: 9,
    sections: [
      {
        id: "s1",
        heading: "一、相关罪名的基本构成",
        paragraphs: [
          "对家庭成员或亲属实施的性侵行为，可能涉及强奸罪、强制猥亵罪、猥亵儿童罪等罪名。此类犯罪侵害的是他人的人身权利与性自主权，属于严重刑事犯罪。",
          "当被害人为未成年人时，法律对其性自主权给予更高程度的保护，相关罪名的成立要件与法定刑也更为严格。",
        ],
      },
      {
        id: "s2",
        heading: "二、亲属身份为何被特别关注",
        paragraphs: [
          "亲属身份在实务中往往被视为重要的量刑考量因素。一方面，行为人通常对被害人具有事实上的影响力或控制力；另一方面，被害人在家庭环境中更难寻求外部帮助，取证与救助难度更大。",
          "正因如此，在符合法律规定的前提下，对利用亲属身份或监护、教养关系实施侵害的行为，司法实践中通常会给予更重的否定评价。",
        ],
      },
      {
        id: "s3",
        heading: "三、证据认定的难点",
        paragraphs: [
          "此类案件多发于私密空间，直接证据往往有限，因此对间接证据、被害人陈述与其他证据的相互印证要求较高。办案机关需遵循证据裁判原则，既不轻信也不苛求。",
          "同时，应注重未成年被害人的特殊保护，避免在取证过程中造成二次伤害，并为其提供必要的心理支持与法律援助。",
        ],
      },
      {
        id: "s4",
        heading: "四、与民事、保护规范的衔接",
        paragraphs: [
          "刑事案件的处理并非终点，还需与监护权撤销、人身安全保护令等民事与保护措施相衔接，形成对被害人的持续保护。",
          "对读者而言，理解这些规范的意义在于：法律对亲属间的性侵害持明确否定立场，遭遇侵害时应及时报警并寻求专业机构帮助。",
        ],
      },
    ],
  },
  {
    id: "laws-03",
    category: "laws",
    title: "比较法视野：不同法域对近亲性行为的规制",
    summary:
      "概述大陆法系与英美法系在近亲性行为规制上的异同，帮助读者理解法律背后的文化与制度差异，避免以单一标准作出简单判断。",
    date: "2026-06-22",
    author: "本站编辑部",
    source: "依公开比较法资料整理",
    tags: ["比较法", "立法模式", "公共秩序"],
    region: "国际比较",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=Open%20legal%20code%20book%20with%20highlighted%20clauses%2C%20macro%20detail%20of%20text%20on%20paper%2C%20warm%20neutral%20and%20navy%20tones%2C%20professional%20documentation%20still%20life%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=800&height=600&seq=cov-c8-law-2026a&orientation=landscape",
    readTime: 7,
    sections: [
      {
        id: "s1",
        heading: "一、两种主要的规制模式",
        paragraphs: [
          "在比较法上，对近亲性行为的规制大致可分为两类：一类以刑法明确规定相关罪名，直接设定刑罚；另一类主要通过婚姻禁制与家庭法规范予以调整，刑法介入相对有限。",
          "许多法域同时采用两种手段：既禁止禁婚亲属结婚，又以不同程度对近亲性行为作出否定评价，只是在罪名设置与处罚力度上存在差异。",
        ],
      },
      {
        id: "s2",
        heading: "二、影响立法差异的因素",
        paragraphs: [
          "立法差异与宗教传统、家庭结构、社会观念以及隐私权保护水平密切相关。同一行为在不同文化背景下的法律评价可能明显不同。",
          "因此，在进行比较研究时，应结合具体法域的社会语境，避免脱离背景进行简单的优劣评判。",
        ],
      },
      {
        id: "s3",
        heading: "三、公共秩序与跨国情形",
        paragraphs: [
          "在跨国婚姻或跨境案件中，一国可能以“公共秩序保留”为由，拒绝承认依外国法成立但违反本国基本伦理与公共秩序的关系。",
          "这一机制体现了各国在维护基本社会伦理方面的保留，也提示我们在研究涉外问题时需同时关注冲突法规则。",
        ],
      },
    ],
  },
  {
    id: "laws-04",
    category: "laws",
    title: "民法典婚姻家庭编中的禁婚亲属范围与登记实务",
    summary:
      "结合婚姻登记实务，说明禁婚亲属声明、登记审查以及婚姻无效确认的程序要点，帮助读者理解制度如何落地。",
    date: "2026-05-14",
    author: "本站编辑部",
    source: "依公开法律法规整理",
    tags: ["婚姻登记", "程序规范", "民法典"],
    region: "中国",
    year: 2021,
    cover:
      "https://readdy.ai/api/search-image?query=Neatly%20arranged%20legal%20statute%20volumes%20on%20a%20shelf%20with%20soft%20window%20light%2C%20deep%20blue%20spines%20and%20warm%20wood%20tones%2C%20orderly%20professional%20atmosphere%2C%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=cov-c2-law-2026b&orientation=landscape",
    readTime: 6,
    sections: [
      {
        id: "s1",
        heading: "一、登记环节的禁婚审查",
        paragraphs: [
          "在婚姻登记环节，双方需对是否存在禁婚亲属关系等法定禁止情形作出声明。登记机关依法进行形式审查，并对当事人负责。",
          "由于登记以当事人声明为基础，隐瞒禁婚关系而取得的登记并不因此当然有效，利害关系人仍可通过诉讼请求确认婚姻无效。",
        ],
      },
      {
        id: "s2",
        heading: "二、无效婚姻的确认程序",
        paragraphs: [
          "确认婚姻无效一般通过诉讼程序进行。有权请求的主体通常包括当事人及利害关系人，法院经审理后以判决确认。",
          "被确认无效的婚姻自始无效，当事人不具有夫妻关系，相关财产与子女问题依照法律另行处理。",
        ],
      },
      {
        id: "s3",
        heading: "三、给读者的提示",
        paragraphs: [
          "对普通公众而言，理解禁婚亲属范围有助于在婚前如实声明、避免法律风险；对法律从业者而言，则需准确计算亲属代数并关注相关程序规范。",
          "本页内容为知识普及，具体个案请以现行法律与司法裁判为准。",
        ],
      },
    ],
  },
  {
    id: "laws-05",
    category: "laws",
    title: "未成年人保护视角下的亲属性侵防治法律规定",
    summary:
      "从强制报告、人身安全保护令到监护权撤销，梳理我国在预防与处置亲属性侵未成年人方面的主要制度安排。",
    date: "2026-04-09",
    author: "本站编辑部",
    source: "依公开法律法规整理",
    tags: ["未成年人保护", "强制报告", "保护令"],
    region: "中国",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20paper%20cut%20illustration%20of%20small%20figures%20sheltered%20under%20a%20protective%20arc%2C%20muted%20navy%20teal%20and%20warm%20neutral%20tones%2C%20calm%20serious%20protective%20concept%2C%20editorial%20minimal%20design%2C%20no%20faces&width=800&height=600&seq=cov-c5-law-2026a&orientation=landscape",
    readTime: 8,
    sections: [
      {
        id: "s1",
        heading: "一、强制报告制度",
        paragraphs: [
          "密切接触未成年人的机构及其工作人员，在工作中发现未成年人身心健康受到侵害或面临危险时，负有及时报告的义务。这一制度有助于将隐蔽的家庭内侵害及早发现。",
          "报告制度的意义在于打破“家务事外人不好插手”的沉默，将家庭内部的风险纳入社会保护网络。",
        ],
      },
      {
        id: "s2",
        heading: "二、人身安全保护令与监护权撤销",
        paragraphs: [
          "当未成年人遭受家庭暴力或面临现实危险时，可依法申请人身安全保护令；在监护人严重侵害被监护人权益的情形下，法院可依法撤销其监护人资格并另行指定监护人。",
          "这些措施与刑事追诉相互配合，形成对未成年人的持续、立体保护，避免侵害在程序结束后继续发生。",
        ],
      },
      {
        id: "s3",
        heading: "三、救助与支持资源",
        paragraphs: [
          "遭遇侵害时，应及时报警并联系学校、妇联、未成年人保护机构等专业力量，必要时寻求法律援助与心理支持。",
          "保护未成年人是全社会的共同责任，任何发现疑似侵害的线索都值得认真对待。",
        ],
      },
    ],
  },

  {
    id: "ethics-01",
    category: "ethics",
    title: "从伤害原则看近亲性关系的伦理争议",
    summary:
      "以密尔的伤害原则为分析起点，探讨近亲性关系为何通常被伦理与法律否定，以及如何在讨论中保持理性与克制。",
    date: "2026-08-02",
    author: "本站编辑部",
    source: "依公开伦理学文献整理",
    tags: ["伤害原则", "伦理分析", "公共讨论"],
    region: "伦理研究",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20ethical%20balance%20concept%20with%20smooth%20balanced%20stones%20stacked%20on%20a%20matte%20surface%2C%20muted%20navy%20and%20teal%20palette%2C%20soft%20diffused%20light%2C%20minimalist%20philosophical%20mood%2C%20no%20people&width=800&height=600&seq=cov-c6-eth-2026a&orientation=landscape",
    readTime: 9,
    sections: [
      {
        id: "s1",
        heading: "一、伤害原则的提出",
        paragraphs: [
          "在伦理与政治哲学中，伤害原则主张：对他人造成伤害的行为，社会可以加以干预与限制。这一原则为讨论个人自由与社会规范的边界提供了一个基本框架。",
          "将伤害原则用于分析近亲性关系，关键在于识别其中可能存在的具体伤害，而非仅凭情感上的反感到即下结论。",
        ],
      },
      {
        id: "s2",
        heading: "二、可识别的伤害",
        paragraphs: [
          "在家庭环境中，成员之间往往存在年龄、经验与权力上的不对等，这使得真正的、自由的同意难以获得保障。当涉及未成年人时，伤害的可能性尤为突出。",
          "此外，家庭作为一个以信任和安全为基础的单位，其内部关系若被卷入性关系，可能破坏家庭成员尤其是未成年人的安全感与角色认知，构成长期的心理伤害。",
        ],
      },
      {
        id: "s3",
        heading: "三、理性讨论的边界",
        paragraphs: [
          "伦理讨论的价值在于澄清理由，而非猎奇或挑衅。我们主张在公共讨论中保持克制，尊重受害者，避免将严肃的伦理议题娱乐化。",
          "需要强调的是，承认某一议题可以被学术讨论，绝不等于为其行为辩护；法律对相关行为的否定立场是清晰而明确的。",
        ],
      },
    ],
  },
  {
    id: "ethics-02",
    category: "ethics",
    title: "权力不对等与知情同意：家庭关系中的伦理边界",
    summary:
      "解释同意为何必须是充分知情的、自愿的，并说明家庭内部权力不对等为何会影响同意的有效性。",
    date: "2026-07-16",
    author: "本站编辑部",
    source: "依公开伦理学文献整理",
    tags: ["知情同意", "权力关系", "伦理边界"],
    region: "伦理研究",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20concept%20of%20power%20imbalance%20represented%20by%20unequal%20geometric%20blocks%20on%20a%20soft%20gradient%20background%2C%20muted%20navy%20and%20teal%20tones%2C%20clean%20minimalist%20editorial%20design%2C%20no%20people&width=800&height=600&seq=cov-c5-eth-2026a&orientation=landscape",
    readTime: 8,
    sections: [
      {
        id: "s1",
        heading: "一、何为有效的同意",
        paragraphs: [
          "伦理意义上的同意，必须是自愿的、充分知情的，并且作出同意的人具备相应的理解与判断能力。缺少其中任何一项，同意的有效性都会受到质疑。",
          "在亲密或家庭关系中，同意的判断尤其复杂，因为情感依赖、经济依附与权威关系可能使当事人难以自由地说“不”。",
        ],
      },
      {
        id: "s2",
        heading: "二、家庭中的权力不对等",
        paragraphs: [
          "家庭成员之间通常存在明显的权力差异：年龄、抚养关系、经济来源与情感依赖都可能构成影响。这种不对等使得表面上的“同意”未必是真正自主的选择。",
          "正因如此，法律与伦理对涉及监护、教养等从属关系的情形设置了更严格的评价标准，以保护处于弱势的一方。",
        ],
      },
      {
        id: "s3",
        heading: "三、保护弱势与尊崇自主的平衡",
        paragraphs: [
          "尊重个人自主与保护弱势一方，并非彼此对立。真正尊重自主，恰恰意味着要确保同意是在没有胁迫、没有误导、具备能力的前提下作出的。",
          "这一标准同样适用于其他存在显著权力落差的关系，具有普遍的伦理意义。",
        ],
      },
    ],
  },
  {
    id: "ethics-03",
    category: "ethics",
    title: "“厌恶论证”能否作为伦理依据？情感与理性的边界",
    summary:
      "探讨以强烈情感反应作为道德理由是否成立，分析“厌恶”在伦理判断中的位置与局限。",
    date: "2026-06-08",
    author: "本站编辑部",
    source: "依公开伦理学文献整理",
    tags: ["道德情感", "伦理推理", "哲学分析"],
    region: "伦理研究",
    year: 2021,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20of%20smooth%20matte%20shapes%20suggesting%20reason%20and%20emotion%2C%20muted%20navy%20teal%20and%20warm%20beige%20tones%2C%20soft%20studio%20lighting%2C%20calm%20philosophical%20editorial%20concept%2C%20no%20people&width=800&height=600&seq=cov-c6-eth-2026b&orientation=landscape",
    readTime: 7,
    sections: [
      {
        id: "s1",
        heading: "一、情感作为道德信号的争议",
        paragraphs: [
          "在伦理讨论中，有人主张强烈的厌恶感本身就是某种行为不当的证据。这一“厌恶论证”在学理上长期受到质疑。",
          "批评者指出，厌恶可能源于偏见、习俗或对陌生事物的不适，未必指向真实的伤害，历史上不少歧视性规范也曾以厌恶为理由。",
        ],
      },
      {
        id: "s2",
        heading: "二、为何仍需回到伤害与理由",
        paragraphs: [
          "因此，伦理判断更稳妥的做法，是回到可检验的理由：是否存在伤害、是否涉及弱势保护、是否破坏基本的信任与自主。",
          "以近亲性关系为例，即便撇开情感上的强烈反感，也可以从权力不对等、未成年人保护与家庭信任等角度给出实质性的伦理理由。",
        ],
      },
      {
        id: "s3",
        heading: "三、情感与理性的正确定位",
        paragraphs: [
          "情感反应并非毫无价值，它常常提示我们某些重要价值受到冲击。但情感本身不足以单独构成结论，仍需经由理性的检验与论证。",
          "成熟的伦理讨论，应当既尊重真实的情感体验，又不被未经审视的直觉所左右。",
        ],
      },
    ],
  },
  {
    id: "ethics-04",
    category: "ethics",
    title: "代际伦理与家庭信任：亲属关系的社会功能",
    summary:
      "从家庭作为信任共同体的角度，分析为何维护清晰的亲属边界对社会具有重要意义。",
    date: "2026-04-27",
    author: "本站编辑部",
    source: "依公开社会伦理研究整理",
    tags: ["家庭伦理", "社会规范", "信任"],
    region: "伦理研究",
    year: 2020,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20paper%20cut%20composition%20of%20nested%20protective%20arcs%20symbolizing%20family%20and%20trust%2C%20muted%20navy%20teal%20and%20neutral%20tones%2C%20clean%20minimal%20editorial%20design%2C%20no%20faces&width=800&height=600&seq=cov-c5-eth-2026b&orientation=landscape",
    readTime: 6,
    sections: [
      {
        id: "s1",
        heading: "一、家庭作为信任共同体",
        paragraphs: [
          "家庭在社会结构中承担着抚养、教育与情感支持等多重功能，其运作依赖于成员之间高度而持续的信任。",
          "这种信任使未成年人能够在安全的环境中成长，也使代际之间的照护与传承成为可能。清晰的亲属边界，是这一信任得以维系的前提之一。",
        ],
      },
      {
        id: "s2",
        heading: "二、边界模糊的代价",
        paragraphs: [
          "当亲属间的关系逾越边界、卷入性关系时，家庭成员的角色认知可能发生混乱，信任被侵蚀，处于弱势地位的成员尤其容易受到伤害。",
          "因此，维护亲属边界不仅是道德要求，也具有维护社会基本秩序的功能意义。",
        ],
      },
      {
        id: "s3",
        heading: "三、规范与关怀并不冲突",
        paragraphs: [
          "强调边界与规范，并不意味着对身处困境的家庭成员缺乏关怀。恰恰相反，明确边界有助于保护家庭中最脆弱的成员。",
          "在讨论此类议题时，理解其社会功能，有助于我们超越单纯的禁忌，给出更有说服力的理由。",
        ],
      },
    ],
  },
  {
    id: "ethics-05",
    category: "ethics",
    title: "伦理教育与公众认知：如何理性讨论禁忌话题",
    summary:
      "讨论在普法与伦理教育中，如何既尊重敏感性，又保持知识的准确与客观，避免猎奇与误读。",
    date: "2026-03-15",
    author: "本站编辑部",
    source: "依公开教育研究整理",
    tags: ["伦理教育", "媒介素养", "公共认知"],
    region: "伦理研究",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Open%20book%20with%20soft%20light%20and%20abstract%20floating%20geometric%20notes%20around%20it%2C%20muted%20navy%20and%20teal%20palette%2C%20calm%20educational%20editorial%20mood%2C%20minimal%20clean%20composition%2C%20no%20people&width=800&height=600&seq=cov-c8-eth-2026a&orientation=landscape",
    readTime: 7,
    sections: [
      {
        id: "s1",
        heading: "一、禁忌话题的教育困境",
        paragraphs: [
          "涉及敏感伦理与法律的内容，若完全不谈，公众容易因缺乏准确信息而产生误解；若谈之不慎，又可能陷入猎奇或渲染。",
          "因此，普法与伦理教育需要在“回避”与“渲染”之间找到一条理性的中间道路。",
        ],
      },
      {
        id: "s2",
        heading: "二、准确、克制与对受害者的尊重",
        paragraphs: [
          "准确，意味着以现行法律与可靠研究为依据；克制，意味着拒绝猎奇式的细节描写；尊重，意味着始终把受害者与弱势群体的处境放在首位。",
          "三者的结合，能够使严肃议题得到负责任地呈现，也让读者获得真正有用的知识。",
        ],
      },
      {
        id: "s3",
        heading: "三、给读者的建议",
        paragraphs: [
          "在接触相关话题时，建议优先参考权威法律文本与专业机构材料，警惕以耸动标题吸引流量的内容。",
          "培养批判性的媒介素养，是每一位现代公民理性参与公共讨论的基础。",
        ],
      },
    ],
  },

  {
    id: "cases-01",
    category: "cases",
    title: "虚构案例：禁婚亲属登记结婚的效力争议",
    summary:
      "以虚构案例演示禁婚亲属隐瞒关系办理结婚登记后，利害关系人如何通过诉讼请求确认婚姻无效。",
    date: "2026-08-11",
    author: "本站编辑部",
    source: "教学虚构案例，非真实个案",
    tags: ["婚姻无效", "虚构案例", "程序"],
    region: "中国",
    year: 2020,
    caseType: "婚姻效力",
    cover:
      "https://readdy.ai/api/search-image?query=Wooden%20judge%20gavel%20and%20closed%20case%20file%20on%20a%20dark%20desk%2C%20deep%20navy%20tones%20with%20a%20subtle%20red%20accent%2C%20professional%20legal%20still%20life%2C%20soft%20shadows%2C%20no%20people&width=800&height=600&seq=cov-c4-case-2026a&orientation=landscape",
    readTime: 7,
    sections: [
      {
        id: "s1",
        heading: "一、案情设定（虚构）",
        paragraphs: [
          "本案例为教学目的虚构：甲与乙系三代以内旁系血亲，二人明知该关系仍在某地婚姻登记机关办理了结婚登记，后因家庭矛盾，甲的近亲属诉请确认该婚姻无效。",
          "需要说明的是，案例中的当事人、情节均为虚构，仅用于演示相关法律规则的适用。",
        ],
      },
      {
        id: "s2",
        heading: "二、争议焦点",
        paragraphs: [
          "焦点之一：登记机关已办理登记，是否意味着婚姻有效？答案是，登记只是形式要件，若存在法律禁止情形，仍可依法确认无效。",
          "焦点之二：谁有权提出请求？一般包括当事人及利害关系人，法院经审理后以判决确认婚姻无效。",
        ],
      },
      {
        id: "s3",
        heading: "三、裁判思路（教学分析）",
        paragraphs: [
          "法院首先审查双方亲属关系是否落入禁婚范围，其次确认是否存在其他影响效力的事由，最后依法处理由此产生的财产与子女问题。",
          "本案例旨在说明：形式上的登记不能掩盖实体上的禁止情形，法律的强制性规定不容规避。",
        ],
      },
    ],
  },
  {
    id: "cases-02",
    category: "cases",
    title: "虚构案例：亲属间性侵案件的证据与量刑分析",
    summary:
      "以虚构案例演示在隐蔽环境下发生的侵害案件中，证据印证与量刑考量的一般思路。",
    date: "2026-07-05",
    author: "本站编辑部",
    source: "教学虚构案例，非真实个案",
    tags: ["刑事案件", "证据规则", "虚构案例"],
    region: "中国",
    year: 2021,
    caseType: "刑事",
    cover:
      "https://readdy.ai/api/search-image?query=Neatly%20stacked%20legal%20documents%20and%20a%20pen%20on%20a%20dark%20wood%20desk%2C%20deep%20navy%20and%20amber%20tones%2C%20serious%20professional%20atmosphere%2C%20editorial%20still%20life%2C%20no%20people&width=800&height=600&seq=cov-c4-case-2026b&orientation=landscape",
    readTime: 8,
    sections: [
      {
        id: "s1",
        heading: "一、案情设定（虚构）",
        paragraphs: [
          "本案例为教学目的虚构：某成年亲属对未成年被害人实施了侵害行为，案件发生于私密家庭环境中，直接证据有限。",
          "全部人物与情节均为虚构，与任何真实案件无关。",
        ],
      },
      {
        id: "s2",
        heading: "二、证据认定要点",
        paragraphs: [
          "此类案件中，被害人陈述往往居于核心地位，但需与其他证据相互印证，形成完整的证据链。办案机关应遵循证据裁判原则，既不轻信也不苛求被害人。",
          "同时，应注意对未成年被害人的特殊保护，减少重复询问，提供必要的心理与法律援助。",
        ],
      },
      {
        id: "s3",
        heading: "三、量刑考量",
        paragraphs: [
          "在符合法律规定的前提下，行为人利用亲属身份或从属关系实施侵害的，通常会被赋予更重的否定评价，体现在量刑上即为从重考量。",
          "本案例的教学价值在于说明：法律对亲属间侵害持明确否定立场，被害人应及时寻求报警与专业机构帮助。",
        ],
      },
    ],
  },
  {
    id: "cases-03",
    category: "cases",
    title: "虚构案例：猥亵儿童罪中亲属身份的从重情节",
    summary:
      "以虚构案例说明亲属或特殊职责人员在猥亵儿童案件中的从重考量，以及未成年人保护的特殊规则。",
    date: "2026-05-29",
    author: "本站编辑部",
    source: "教学虚构案例，非真实个案",
    tags: ["未成年人保护", "从重情节", "虚构案例"],
    region: "中国",
    year: 2022,
    caseType: "刑事",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20legal%20shield%20made%20of%20thin%20geometric%20lines%20on%20a%20dark%20navy%20background%2C%20subtle%20teal%20and%20red%20accents%2C%20modern%20protective%20concept%2C%20minimalist%20editorial%20design%2C%20no%20people&width=800&height=600&seq=cov-c7-case-2026a&orientation=landscape",
    readTime: 7,
    sections: [
      {
        id: "s1",
        heading: "一、案情设定（虚构）",
        paragraphs: [
          "本案例为教学目的虚构：负有照护职责的某亲属对儿童实施了猥亵行为。案例为教学演示，人物情节均属虚构。",
          "涉及儿童的内容遵循最有利于未成年人的原则，仅作法律分析，不作任何细节渲染。",
        ],
      },
      {
        id: "s2",
        heading: "二、法律适用",
        paragraphs: [
          "对儿童实施的猥亵行为，法律给予更严格的评价。若行为人系儿童的亲属或负有特殊职责的人员，通常构成从重考量情节。",
          "法律之所以作此规定，是因为这类人员本应承担保护义务，其侵害行为对儿童造成的信任破坏尤为严重。",
        ],
      },
      {
        id: "s3",
        heading: "三、延伸保护",
        paragraphs: [
          "刑事判决之后，还应结合监护权撤销、人身安全保护令等民事与保护措施，为儿童提供持续保护。",
          "任何怀疑儿童受到侵害的情形，都应当认真对待并及时报告。",
        ],
      },
    ],
  },
  {
    id: "cases-04",
    category: "cases",
    title: "虚构案例：监护权撤销与未成年人保护衔接",
    summary:
      "以虚构案例演示在监护人严重侵害未成年人权益时，撤销监护资格并另行指定监护人的适用思路。",
    date: "2026-04-18",
    author: "本站编辑部",
    source: "教学虚构案例，非真实个案",
    tags: ["监护权撤销", "未成年人保护", "虚构案例"],
    region: "中国",
    year: 2023,
    caseType: "民事保护",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20paper%20cut%20illustration%20of%20a%20protective%20hand%20shape%20sheltering%20small%20figures%2C%20muted%20navy%20teal%20and%20warm%20neutral%20tones%2C%20calm%20protective%20editorial%20concept%2C%20no%20faces&width=800&height=600&seq=cov-c5-case-2026a&orientation=landscape",
    readTime: 6,
    sections: [
      {
        id: "s1",
        heading: "一、案情设定（虚构）",
        paragraphs: [
          "本案例为教学目的虚构：某监护人严重侵害被监护人权益，有关部门依法申请撤销其监护人资格并另行指定监护人。",
          "案例中的人物、情节均为虚构，仅用于演示法律制度的适用。",
        ],
      },
      {
        id: "s2",
        heading: "二、制度要点",
        paragraphs: [
          "撤销监护人资格的目的是保护被监护人，而非惩罚监护人。在撤销后，应当及时另行指定监护人，避免出现监护真空。",
          "相关工作需与民政、未成年人保护机构等协同开展，确保未成年人得到妥善安置与持续关怀。",
        ],
      },
      {
        id: "s3",
        heading: "三、制度意义",
        paragraphs: [
          "这一制度体现了“国家亲权”的理念：当家庭无法保护未成年人时，国家有责任介入并承担保护职责。",
          "对公众而言，了解这类制度有助于在发现未成年人处于危险时知道可以向谁求助。",
        ],
      },
    ],
  },
  {
    id: "cases-05",
    category: "cases",
    title: "虚构案例：跨境婚姻中禁婚亲属的承认与公共秩序",
    summary:
      "以虚构案例演示跨国情形下，一国如何以公共秩序保留为由处理禁婚亲属关系的承认问题。",
    date: "2026-03-02",
    author: "本站编辑部",
    source: "教学虚构案例，非真实个案",
    tags: ["涉外", "公共秩序", "虚构案例"],
    region: "涉外",
    year: 2019,
    caseType: "涉外",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20globe%20made%20of%20thin%20geometric%20lines%20with%20subtle%20connecting%20nodes%2C%20deep%20navy%20and%20teal%20palette%2C%20modern%20international%20law%20concept%2C%20clean%20editorial%20design%2C%20no%20people&width=800&height=600&seq=cov-c3-case-2026a&orientation=landscape",
    readTime: 6,
    sections: [
      {
        id: "s1",
        heading: "一、案情设定（虚构）",
        paragraphs: [
          "本案例为教学目的虚构：当事人依某一外国法成立的关系，在其本国因违反基本伦理与公共秩序而不被承认。",
          "案例为教学演示，人物与情节均为虚构。",
        ],
      },
      {
        id: "s2",
        heading: "二、公共秩序保留",
        paragraphs: [
          "在国际私法中，公共秩序保留允许一国拒绝适用或承认明显违反其基本社会伦理与公共秩序的外国法或外国决定。",
          "这一机制的适用应当审慎，需结合本国基本价值判断，避免滥用而过度限制国际交往。",
        ],
      },
      {
        id: "s3",
        heading: "三、教学启示",
        paragraphs: [
          "涉外案件提示我们，法律评价具有语境性。研究比较法与冲突法时，既要理解差异，也要把握各国维护基本伦理的底线。",
          "本案例仅作知识普及，具体问题请咨询专业法律人士。",
        ],
      },
    ],
  },
];